import React, { useCallback, useEffect } from "react";
import moment from "moment";
import striptags from "striptags";
import Link from "next/link";
import { getLastestArticles } from "../../store/apps/blog";
import { useSelector, useDispatch } from "react-redux";
import Image from "next/image";

const Article = ({ data }) => {
  const dispatch = useDispatch();

  const latestArticles = useSelector((state) => state.blog.lastestArticlesData);

  const fetchLastest = useCallback(() => {
    dispatch(getLastestArticles("data"));
  }, [dispatch]);

  useEffect(() => {
    fetchLastest();
  }, []);

  return (
    <section className="article-section">
      <div className="article-inner">
        <div className="container">
          <div className="row">
            {latestArticles?.body?.map((val, i) => {
              // const titleWithoutPTag = striptags(val?.value?.heading);
              const titleWithoutPTag = val?.value?.heading || "";
              if (val?.type == "articles") {
                return (
                  <div className="col-lg-12" key={i}>
                    <div className="article-heading">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: titleWithoutPTag,
                        }}
                      ></span>
                    </div>
                  </div>
                );
              }
            })}
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-12">
              {latestArticles &&
                latestArticles?.body?.map((val, i) => {
                  if (val?.type == "articles") {
                    return (
                      <React.Fragment key={i}>
                        {val?.value?.articles?.map((val, index) => {
                          const formattedDate = moment(
                            val?.value?.date_published
                          ).format("MMMM Do, YYYY");
                          if (index == 0) {
                            return (
                              <Link
                                href={`/blog/${val?.value?.slug}`}
                                key={`${index}_j`}
                              >
                                <div className="latest-article-card">
                                  <div className="latest-article-img">
                                    <Image
                                      src={val?.value?.image}
                                      alt="articalimg"
                                      height={500}
                                      width={500}
                                      loading="eager"
                                    />
                                    <span className="computing-link">
                                      {val?.value?.category}
                                    </span>
                                  </div>
                                  <div className="latest-article-content">
                                    <span className="article-date-time">
                                      {formattedDate}
                                      <span className="article-time">{val?.value?.reading_times}</span>
                                    </span>
                                    <span className="article-title">{val?.value?.title}</span>
                                    <p className="article-description">{striptags(val?.value?.description)}</p>
                                  </div>
                                </div>
                              </Link>
                            );
                          }
                        })}
                      </React.Fragment>
                    );
                  }
                })}
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="latest-article-all-card">
                {latestArticles &&
                  latestArticles?.body?.map((val, index) => {
                    if (val?.type == "articles") {
                      return (
                        <React.Fragment key={index}>
                          {val?.value?.articles?.slice(1)?.map((val, i) => {
                            const formattedDate = moment(
                              val?.value?.date_published
                            ).format("MMMM Do, YYYY");
                            return (
                              <Link
                                href={`/blog/${val?.value?.slug}`}
                                key={`${i}_j`}
                              >
                                <div className="latest-article-card">
                                  <div className="latest-article-img">
                                    <Image
                                      src={val?.value?.image}
                                      alt="articalimg"
                                      height={500}
                                      width={500}
                                      loading="eager"
                                    />
                                    <span className="computing-link">
                                      {val?.value?.category}
                                    </span>
                                  </div>
                                  <div className="latest-article-content">
                                    <span className="article-date-time">
                                      {formattedDate}
                                      <span className="article-time">{val?.value?.reading_times}</span>
                                    </span>
                                    <span className="title-text">{val?.value?.title}</span>
                                    <p className="description-text">
                                      {striptags(val?.value?.description)}
                                    </p>
                                  </div>
                                </div>
                              </Link>
                            );
                          })}
                        </React.Fragment>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Article;
